module.exports = __webpack_public_path__ + "media/images/icons/refund-f3d7c7ab246e104fb67176580e0451a6.svg";